/*
This file is located in the main branch
Last time the file was updated (UTC): [11.12.2024 08:50:34]
Permissions to update outside the main branch: [false]
*/

import {
    DynamicListAddButton,
    DynamicListWrapperProps,
    useWorkplaceState,
    ValidatedDynamicListFormComponentProps,
    ValidatedLinkedDropDownList,
} from '@finbeat/react-toolkit';
import { getOutletList, getTradeOrgList } from 'axios/questionaryApi';
import useApi from 'hooks/useApi';
import { QuestionaryInfo, QuestionaryTable } from 'models/api/questionary';
import { Trans, useTranslation } from 'react-i18next';
import { Table } from 'reactstrap';
import { DropDownForm } from './QuestionaryModal';
import './QuestionaryModal.scss';

const QuestionariesTradeOrgsFormWrapper = ({ children, ...props }: DynamicListWrapperProps) => {
    return (
        <Table bordered>
            <thead>
                <tr className="align-middle">
                    <th className="w-45">
                        <Trans i18nKey={'BackOfficeTradeOrg'} />
                    </th>
                    <th className="w-45">
                        <Trans i18nKey={'BackOfficeOutlet'} />
                    </th>
                    <th className="w-10 text-center">
                        <DynamicListAddButton {...props} />
                    </th>
                </tr>
            </thead>
            <tbody>{children}</tbody>
        </Table>
    );
};

const QuestionariesTradeOrgsForm = ({
    innerRef,
    idx,
    fieldId,
    checkDouble,
}: ValidatedDynamicListFormComponentProps) => {
    const api = useApi();
    const { t } = useTranslation();
    const { tableData, currentItem } = useWorkplaceState<QuestionaryTable>();

    const validator = (value?: DropDownForm) => {
        const double = checkDouble(fieldId);
        if (double) {
            return double;
        }

        if (!value || (!value.id && !value.name)) return t('BackOfficeTradeOrgNotSpecified');

        if (
            value.name &&
            tableData.data.some(
                (x) =>
                    x.id !== currentItem?.id &&
                    x.tradeOrgs &&
                    x.tradeOrgs.includes(value.name ?? '')
            )
        ) {
            return t('BackOfficeProfileAlreadyExistsForTOMsg');
        }
    };

    return (
        <>
            <td>
                <ValidatedLinkedDropDownList<QuestionaryInfo>
                    fetchQueryFn={() => getTradeOrgList(api, null)}
                    queryKey="tradeOrgList"
                    name={`tradeOrgs.${idx}.tradeOrgId`}
                    innerRef={innerRef}
                    rules={{
                        validate: validator,
                    }}
                    isFloating={false}
                    isClearable={false}
                />
            </td>
            <td>
                <ValidatedLinkedDropDownList<QuestionaryInfo>
                    fetchQueryFn={(id) => getOutletList(api, id, null)}
                    queryKey="outletList"
                    name={`tradeOrgs.${idx}.outletId`}
                    parent={`tradeOrgs.${idx}.tradeOrgId`}
                    innerRef={innerRef}
                />
            </td>
        </>
    );
};

export { QuestionariesTradeOrgsForm, QuestionariesTradeOrgsFormWrapper };
